var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 20V19H17C13.7905 19 10.6333 20.0653 8.05278 21.3556C6.53645 22.1137 5.18823 22.9652 4.11338 23.7595C4.55598 19.5861 6.24713 17.031 8.34833 15.462C10.8553 13.5899 14.1073 13 17 13H18V12V6.41421L27.5858 16L18 25.5858V20Z","stroke":"currentColor","strokeWidth":"2"}));
}

Share.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Share;

Share.default = Share;
